import { render, staticRenderFns } from "./save4CZJ.vue?vue&type=template&id=a66bffc4&scoped=true"
import script from "./save4CZJ.vue?vue&type=script&lang=js"
export * from "./save4CZJ.vue?vue&type=script&lang=js"
import style0 from "./save4CZJ.vue?vue&type=style&index=0&id=a66bffc4&prod&lang=scss"
import style1 from "./save4CZJ.vue?vue&type=style&index=1&id=a66bffc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66bffc4",
  null
  
)

export default component.exports